import store from '@/store/store'

export const PREP_PURCHASE_FOR_EDIT = ({ id, statusId }: { id: string, statusId: string }) => {
  store.dispatch('data/setEditOrder', { id, statusId })
  store.dispatch('purchase/start')
}
